import { HttpContextToken } from '@angular/common/http'

/** Marks requests whose caller supplies error feedback and a recovery action. */
export const LOCAL_ERROR_FEEDBACK = new HttpContextToken<boolean>(() => false)
